let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1Ojgx")).then(() => parcelRequire('4E1b5'));